const APIUrl = "https://api.makosclock.com/";

export const urlMembresias = {APIUrl}.APIUrl + "membership/";
export const urlAreas = {APIUrl}.APIUrl + "areas/";
export const urlEmpleados = {APIUrl}.APIUrl + "employees/";
export const urlMarcacion = {APIUrl}.APIUrl + "attendance/";